// src/components/AnimatedSection.tsx
import React from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { cn } from '@/lib/utils';

type AnimationVariant = 'fade-in' | 'fade-up' | 'fade-down' | 'fade-left' | 'fade-right';

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  variant?: AnimationVariant;
  delay?: number;
  threshold?: number;
  id?: string;
  as?: React.ElementType;
}

const AnimatedSection = ({
  children,
  className,
  variant = 'fade-up',
  delay = 0,
  threshold = 0.1,
  id,
  as: Component = 'div',
}: AnimatedSectionProps) => {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>({ threshold });

  return (
    <Component
      ref={ref}
      id={id}
      className={cn(
        className,
        isVisible ? `animate-${variant}` : 'opacity-0',
      )}
      style={{
        animationDelay: isVisible ? `${delay}ms` : '0ms',
        animationFillMode: 'forwards',
      }}
    >
      {children}
    </Component>
  );
};

export default AnimatedSection;